export default {"src":"/_next/static/media/lender-dashboard.8e25b1ed.svg","height":19,"width":25};